/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_TitleInputs */

const en_cap_full_title = /** @type {(inputs: Cap_Full_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The whole system, built and run.`)
};

const lv_cap_full_title = /** @type {(inputs: Cap_Full_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa sistēma, izveidota un uzturēta.`)
};

/**
* | output |
* | --- |
* | "The whole system, built and run." |
*
* @param {Cap_Full_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_title = /** @type {((inputs?: Cap_Full_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_title(inputs)
	return en_cap_full_title(inputs)
});